import React, { Component } from 'react';
import ContentRightPrice from '../../report-description/content/content-right/content-right-price/content-right-price';
import config from '../../config';

class Currency extends Component {
    constructor(props) {
        super(props)
        this.state = {
            list: []
        }
       // ContentRightPrice = this;
    }
    handleChange(event)
    {

        ContentRightPrice.getPriceConvert(event.currentTarget.value);

    }
    render() {
        return (
            <div className="styled-select">
                <select id="currency_selected" className="usd" onChange={this.handleChange}>
                        <option value="usd" selected="">USD ($)</option>
                        <option value="inr">INR (₹)</option>
                        <option value="eur">EUR (€)</option>
                        <option value="jpy">JPY (¥)</option>
                        <option value="gbp">GBP (£)</option>
                    </select>
                <span className="">
                    <i className="fa fa-angle-down wht"></i>
                </span>
            </div>

        );

    }


}
export default Currency;


// WEBPACK FOOTER //
// ./src/header/currency/Currency.js